import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

export function useFlightStatusResultsAnalytics(searchParams, results) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const {
    destinationAirportCode = "",
    originationAirportCode = "",
    departureDate = "",
  } = searchParams ?? {};

  useEffect(() => {
    if (pathname.includes("/air/flight-status/results")) {
      setMktgPageData(
        {
          air_bound1_airportcode: `${originationAirportCode}:${destinationAirportCode}`,
          air_bound1_date: departureDate || "",
          air_bound1_flightsreturned: `${results?.length}`,
        },
        "fligthStatusResultsPage"
      );
    }
  }, [pathname, results]);
}
